import {Component, Inject, Injectable, Input, OnDestroy, OnInit} from '@angular/core';
import {MatChipInputEvent, MatDialog, MatDialogConfig, MatDialogRef} from '@angular/material';
import {MAT_DIALOG_DATA} from '@angular/material/typings/dialog';
import {FormBuilder, FormGroup, ValidationErrors, Validators} from '@angular/forms';
import {finalize} from 'rxjs/operators';
import {ApiResponseModel} from '../../../shared/entities/api-response.model';
import {HttpErrorResponse} from '@angular/common/http';
import {ValidationMessageService} from '../../../shared/services/validation-message-handle';
import {ToastrService} from 'ngx-toastr';
import {JobTypeModel} from '../../models/jobType.model';
import {JobTypeService} from '../../services/jobType.service';
import {DeleteDialogComponent} from '../../../shared/components/delete-dialog/delete-dialog.component';
import {JobService} from '../../services/job.service';
import {CityService} from '../../services/city.service';
import {CountyService} from '../../services/county.service';
import {City, County, JobCompetents, JobDepartments, JobModel} from '../../models/job.model';
import {COMMA, ENTER} from '@angular/cdk/keycodes';
import {UserModel} from '../../../auth/models/user.model';
import {CompanyModel} from '../../../auth/models/company.model';
import {CandidateModel} from '../../models/candidate.model';
import {RecommandationModel} from '../../models/recommandation.model';
import {UserService} from '../../../auth/services/user.service';


@Component({
  selector: 'app-create-job',
  templateUrl: './create-job.component.html',
  styleUrls: ['./create-job.component.scss']
})

export class CreateJobComponent implements OnInit, OnDestroy {

  public objectForm: FormGroup;
  public loading: boolean = false;
  public checkUserRecommendation = false;

  readonly separatorKeysCodes: number[] = [ENTER, COMMA];

  public listOfCities: Array<City> = [];
  public listOfCounties: Array<County> = [];
  public listOfJobTypes: Array<JobTypeModel> = [];
  public listOfStudents: Array<UserModel> = [];

  public listOfRecomandations: Array<RecommandationModel> = [];
  public listOfCandidates: Array<CandidateModel> = [];

  public selectedCity: City = null;
  public selectedCounty: County = null;
  public selectedJobType: JobTypeModel = null;
  public selectedCompetentRequired: Array<JobCompetents> = [];
  public selectedDepartmens: Array<JobDepartments> = [];

  public readonly = false;
  public jobDetails: Array<any> = [];
  public selectedStudentForRecommendation: UserModel = null;

  public entityType: string = null;

  constructor(
      @Inject(MAT_DIALOG_DATA)
      public thisObject: JobModel,
      private dialog: MatDialog,
      private dialogRef: MatDialogRef<CreateJobComponent>,
      private _formBuilder: FormBuilder,
      private jobTypeService: JobTypeService,
      private validationMessageService: ValidationMessageService,
      private toastr: ToastrService,
      private jobService: JobService,
      private cityService: CityService,
      private countyService: CountyService,
      public userService: UserService,
  ) {

  }

  ngOnInit(): void {

    this.getJobTypesList();
    this.getListOfCounties();

    this.objectForm = this._formBuilder.group({
      name   : ['', Validators.required],
      jobType: ['', Validators.required],
      county: ['', Validators.required],
      city: ['', Validators.required],
      position: ['', Validators.required],
      industry: ['', Validators.required],
      departments: [''],
      competentRequired: [''],
      validUntil: ['', Validators.required],
      mandatoryRecommendation: [''],
      description: ['', Validators.required],
    });

    console.log(this.thisObject);
    this.entityType = localStorage.getItem('user_entityType');
    if (this.thisObject) {

      this.getCitiesList(this.thisObject.county.uid);

      this.objectForm.patchValue({
        name: this.thisObject.name,
        position: this.thisObject.position,
        industry: this.thisObject.industry,
        validUntil: this.thisObject.validUntil,
        mandatoryRecommendation: this.thisObject.mandatoryRecommendation,
        description: this.thisObject.description,
      });

      this.selectedCity = this.thisObject.city;
      this.selectedCounty = this.thisObject.county;
      // @ts-ignore
      this.selectedCompetentRequired = JSON.parse(this.thisObject.competentRequired);
      // @ts-ignore
      this.selectedDepartmens = JSON.parse(this.thisObject.departments);
      this.selectedJobType = this.thisObject.jobType;

      console.log(this.thisObject);

      if (localStorage.getItem('user_entityType') === 'student'){
        this.getUserRecommendation();
      }


      if (localStorage.getItem('user_entityType') === 'student' || localStorage.getItem('user_entityType') === 'universitate'){

          this.readonly = true;

          const departments = this.selectedDepartmens.map(item => {
            return item.name;
          });

          const competentRequired = this.selectedCompetentRequired.map(item => {
            return item.name;
          });

          this.jobDetails.push(
              {key: 'Denumire', value: this.thisObject.name},
              {key: 'Compania', value: this.thisObject.createdByUser.company.name},
              {key: 'Tip', value: this.thisObject.jobType.name},
              {key: 'Oras', value: this.thisObject.city.name},
              {key: 'Judet', value: this.thisObject.county.name},
              {key: 'Pozitia', value: this.thisObject.position},
              {key: 'Departament', value: departments.join(', ')},
              {key: 'Competente', value: competentRequired.join(', ')},
              {key: 'Industrie', value: this.thisObject.industry},
              {key: 'Valabilitate', value: this.thisObject.validUntil},
              {key: 'Descriere', value: this.thisObject.description}
           );

          this.getListOfStudents();
      }

      this.getCandidates();
      this.getRecommendations();

    }

  }

  getJobTypesList(): void
  {
    this.loading = true;
    this.jobTypeService.getList()
        .pipe(finalize(() => this.loading = false))
        .subscribe((response) => {
          this.listOfJobTypes = response.payload;
        });
  }

  getCitiesList(countyUid: string): void
  {
    this.loading = true;
    this.cityService.getList(countyUid)
        .pipe(finalize(() => this.loading = false))
        .subscribe((response) => {
          this.listOfCities = response.payload;
        });
  }

  getListOfCounties(): void
  {
    this.loading = true;
    this.countyService.getList()
        .pipe(finalize(() => this.loading = false))
        .subscribe((response) => {
          this.listOfCounties = response.payload;
        });
  }

  getRecommendations(): void
  {
    this.loading = true;
    this.jobService.getRecommendationsList(this.thisObject.uid)
        .pipe(finalize(() => this.loading = false))
        .subscribe((response) => {
          this.listOfRecomandations = response.payload;
        });
  }

  makeRecommendations(): void
  {
    this.loading = true;
    this.jobService.makeRecommendations(this.thisObject.uid, this.selectedStudentForRecommendation.uid)
        .pipe(finalize(() => this.loading = false))
        .subscribe((response) => {

          if (response.status === true){
            this.selectedStudentForRecommendation = null;
            this.getRecommendations();

            this.toastr.success('Succes!', 'Job-ul a fost recomandat cu succes!');
          }

        });
  }

  getListOfStudents(): void
  {
    this.loading = true;
    this.userService.getList(this.thisObject.createdByUser.company)
        .pipe(finalize(() => this.loading = false))
        .subscribe((response) => {
          this.listOfStudents = response.payload;
        });
  }

  getCandidates(): void
  {
    this.loading = true;
    this.jobService.getCandidatesList(this.thisObject.uid)
        .pipe(finalize(() => this.loading = false))
        .subscribe((response) => {
          this.listOfCandidates = response.payload;
        });
  }

  ngOnDestroy(): void {

  }

  create(): void
  {

    const data = new JobModel().map(this.objectForm.getRawValue());

    data.city = this.selectedCity;
    data.county = this.selectedCounty;
    data.competentRequired = this.selectedCompetentRequired;
    data.departments = this.selectedDepartmens;
    data.jobType = this.selectedJobType;


    this.loading = true;
    this.jobService.create(data)
        .pipe(finalize(() => this.loading = false))
        .subscribe((response) => {
          this.toastr.success('Succes!', 'Job-ul a fost salvata cu succes!');
          this.dialogRef.close(data);
        }, err => {
          if (err instanceof HttpErrorResponse) {
            this.validationMessageService.serverSideValidation(err, this.objectForm, '' , true);
          }
        });
  }

  update(): void
  {

    const data = new JobModel().map(this.objectForm.getRawValue());

    data.uid = this.thisObject.uid;
    data.city = this.selectedCity;
    data.county = this.selectedCounty;
    data.competentRequired = this.selectedCompetentRequired;
    data.departments = this.selectedDepartmens;
    data.jobType = this.selectedJobType;

    this.loading = true;
    this.jobService.update(data)
        .pipe(finalize(() => this.loading = false))
        .subscribe((response) => {
          this.toastr.success('Succes!', 'Job-ul a fost modificata cu succes!');
          this.dialogRef.close(data);
        }, err => {
          if (err instanceof HttpErrorResponse) {
            this.validationMessageService.serverSideValidation(err, this.objectForm, '' , true);
          }
        });
  }

  onClickSave(): void
  {

    if (this.thisObject) {
      this.update();
    }else{
      this.create();
    }

  }

  onClickCancel(): void
  {
    this.dialogRef.close();

  }

  onDeleteClick(): void {

    const dialogConfig = new MatDialogConfig();
    this.dialog.open(DeleteDialogComponent, dialogConfig).afterClosed().subscribe(result => {
      if(result === true){

        const data = new JobModel().map(this.objectForm.getRawValue());
        data.uid = this.thisObject.uid;
        this.loading = true;
        this.jobService.delete(data)
            .pipe(finalize(() => this.loading = false))
            .subscribe((response) => {
              this.toastr.success('Succes!', 'Job-ul a fost sters cu succes!');
              this.dialogRef.close(this.objectForm.getRawValue());
            }, err => {
              if (err instanceof HttpErrorResponse) {
                this.validationMessageService.serverSideValidation(err, this.objectForm, '' , true);
              }
            });
      }
    });
  }

  compareObjects(o1: any, o2: any): boolean {
    if (o1 && o2){
      return o1.uid === o2.uid;
    }else{
      return false;
    }
  }

  addCompetentRequired(event: MatChipInputEvent): void {
    const input = event.input;
    const value = event.value;

    // Add our fruit
    if ((value || '').trim()) {
      this.selectedCompetentRequired.push(new JobCompetents().map({name: value.trim()}));
    }

    // Reset the input value
    if (input) {
      input.value = '';
    }
  }

  removeCompetentRequired(data: JobCompetents): void {
    const index = this.selectedCompetentRequired.indexOf(data);
    if (index >= 0) {
      this.selectedCompetentRequired.splice(index, 1);
    }
  }

  addDepartments(event: MatChipInputEvent): void {
    const input = event.input;
    const value = event.value;

    // Add our fruit
    if ((value || '').trim()) {
      this.selectedDepartmens.push(new JobDepartments().map({name: value.trim()}));
    }

    // Reset the input value
    if (input) {
      input.value = '';
    }
  }

  removeDepartments(data: JobDepartments): void {
    const index = this.selectedDepartmens.indexOf(data);
    if (index >= 0) {
      this.selectedDepartmens.splice(index, 1);
    }
  }

  onSelectStudent($event: Event):void {
    console.log('onSelectStudent', $event);
  }

  onCountyChange($event: any): void {
    this.getCitiesList($event.uid);
  }

  showApplyButton(): boolean
  {
    return true;
  }


  getUserRecommendation(): void
  {
    this.loading = true;
    this.jobService.checkUserRecommendation(this.thisObject.uid)
        .pipe(finalize(() => this.loading = false))
        .subscribe((response) => {
          this.checkUserRecommendation = (response.payload) ? true: false
        });
  }

  applyAsStudent(): void {
    this.loading = true;
    this.jobService.applyToJob(this.thisObject.uid)
        .pipe(finalize(() => this.loading = false))
        .subscribe((response) => {
          if (response.status === true){
            this.toastr.success('Succes!', 'Ai aplicat cu succes pentru acest job!');
            this.dialogRef.close();
          }
        }, err => {
          if (err instanceof HttpErrorResponse) {
            this.validationMessageService.serverSideValidation(err, this.objectForm, '' , true);
          }
        });
  }
}

